export const TIME_FORMAT = {
	TIME_FORMAT: "HH:mm",
	TIME_SECONDS_FORMAT: "HH:mm:ss",
};

//prettier-ignore
export const parseTime = (value) => {
	if (!value || typeof value !== "string") return null;

	const matches = value.trim().match(/^(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);

	if (!matches) return null;

	const hour = parseInt(matches[1], 10);
	const minute = parseInt(matches[2], 10);

	if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;

	return { hour, minute };
};

export const formatTime = (hour, minute, withSeconds) => {
	const paddedHour = String(hour).padStart(2, "0");
	const paddedMinute = String(minute).padStart(2, "0");
	const time = paddedHour + ":" + paddedMinute;

	return withSeconds ? time + ":00" : time;
};

export const formatTimeValue = (value, withSeconds) => {
	const time = parseTime(value);

	if (!time) return "";

	return formatTime(time.hour, time.minute, withSeconds);
};

export const getTimeInMinutes = (value) => {
	const time = parseTime(value);

	if (!time) return null;

	return time.hour * 60 + time.minute;
};

//prettier-ignore
export const getHourOptions = (minTime, maxTime) => {
	const min = getTimeInMinutes(minTime);
	const max = getTimeInMinutes(maxTime);
	const hours = [];

	for (let hour = 0; hour < 24; hour++) {
		const startOfHour = hour * 60;
		const endOfHour = startOfHour + 59;
		const isDisabled = (min !== null && endOfHour < min) || (max !== null && startOfHour > max);

		hours.push({ value: hour, label: String(hour).padStart(2, "0"), isDisabled });
	}

	return hours;
};

//prettier-ignore
export const getMinuteOptions = (hour, step = 1, minTime, maxTime) => {
	const min = getTimeInMinutes(minTime);
	const max = getTimeInMinutes(maxTime);
	const interval = step > 0 ? step : 1;
	const currentHour = hour > 0 ? hour : 0;
	const minutes = [];

	for (let minute = 0; minute < 60; minute += interval) {
		const totalMinutes = currentHour * 60 + minute;
		const isDisabled = (min !== null && totalMinutes < min) || (max !== null && totalMinutes > max);

		minutes.push({ value: minute, label: String(minute).padStart(2, "0"), isDisabled });
	}

	return minutes;
};
